import PropTypes from "prop-types";
import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Breadcrumbs = (props) => {
  const navigate = useNavigate();
  /**
   * Destructures the `BreadcrumbInner` and `BreadcrumbmainTitle` properties from the `props` object.
   * @param {object} props - The object containing the properties.
   * @returns None
   */
  const {
    BreadcrumbInner,
    BreadcrumbmainTitle,
    innerPagetitle,
    breadcrumbItem,
    pageTitle,
    style,
    backArrow,
    onBackArrow,
  } = props;

  return (
    <React.Fragment>
      <div
        className="page-title-box d-sm-flex align-items-center justify-content-between"
        style={style}
      >
        <div className="backAerrowWrapper">
          {backArrow && (
            <span className="bacArrow" onClick={onBackArrow}>
              <i className="bx bx-arrow-back font-size-18" /> <span>Back</span>
            </span>
          )}
          {BreadcrumbmainTitle && (
            <h4 className="mb-0 font-size-18">{breadcrumbItem}</h4>
          )}
        </div>
        {BreadcrumbInner && (
          <div className="page-title-left">
            <Breadcrumb className="m-0">
              <div className="back-wrapper">
                <div className="Back_btn">
                  <div className="mainTitle">
                    <i className="mdi mdi-home-outline" />
                    {pageTitle.map((item, index) => (
                      // <React.Fragment key={index}>
                      //   <h4 className="mb-0 font-size-18">/</h4>

                      //   <h4 className="mb-0 font-size-18">{item.title}</h4>
                      // </React.Fragment>
                      <React.Fragment key={index}>
                        <h4 className="mb-0 font-size-18">/</h4>
                        {index === pageTitle.length - 1 ? (
                          <h4
                            onClick={() => {
                              navigate(item?.path);
                            }}
                            className="mb-0 font-size-18"
                            style={{ cursor: "pointer" }}
                          >
                            {item.title}
                          </h4>
                        ) : (
                          <h4 className="mb-0 font-size-18">{item.title}</h4>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                  <h4 className="mb-0 font-size-18">/</h4>
                </div>
                <h4 className="mb-0 font-size-18">{innerPagetitle}</h4>
              </div>
            </Breadcrumb>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

/**
 * PropTypes for the Breadcrumbs component.
 * @prop {string} breadcrumbItem - The string representing a single breadcrumb item.
 * @prop {string} title - The string representing the title of the breadcrumbs.
 */
Breadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
};

export default Breadcrumbs;
